import styled from '@emotion/styled';
import React from 'react';
const SpanStyled = styled.span`
    font-weight: bold;
    color: #333;
`;
const ConfirmEnrollDialog = ({ LastFour, paymentDay }) => {
    return (
        <>
            <div>
                <p>
                    By clicking “Enroll,” you are authorizing regularly scheduled charges to your account ending in{' '}
                    <SpanStyled>{LastFour}</SpanStyled>, and agree that your account will be charged each month on day{' '}
                    <SpanStyled>{paymentDay}</SpanStyled> for the total amount due for that period, which is your
                    monthly payment plus applicable fees and taxes.
                </p>
                <p>You agree that no notification will be provided prior to each scheduled payment.</p>
                <p>
                    You understand that this authorization for recurring Autopay remains in effect until your account is
                    paid in full, or until you notify TimePayment of your cancellation in writing at least one week
                    prior to your next scheduled billing date.{' '}
                </p>
                <p>
                    You further agree to notify TimePayment in writing of any changes to your preferred payment method.
                </p>
            </div>
        </>
    );
};

export default ConfirmEnrollDialog;
